// @flow

import * as React from 'react';
import {
  DisabledSocialAction,
  LikeAction,
  NestedSocialAction,
  SocialActionBar,
} from '@ta/social.actions';
import { featureIsEnabled } from '@ta/common.features';
import { ShareCta } from '@ta/public.share-cta';
import { getDisplayName } from '@ta/social.member';

import MediaBatchPhotoSection from '@ta/social.section-media-batch-photo';

import type { MediaBatchPhotoSectionProps } from '@ta/social.section-media-batch-photo';
import SocialStatisticsBar from '@ta/social.statistics-bar';

// Take everything from MediaBatchPhotoSectionProps except socialActionBar
export type Props = $Diff<
  MediaBatchPhotoSectionProps,
  {| socialActionBar?: React.Node, socialStatisticsBar?: React.Node |},
>;

const MediaBatchPhotoSectionWrap = (props: Props) => {
  const metadata = {
    numPhotos: props.photos.length,
    caption: props?.metadata?.caption,
    id: props.metadata.mediaBatchId,
    socialReferences: props.metadata.socialReferences,
    socialStatistics: props.metadata.socialStatistics,
    orderedLocations: props.metadata.orderedLocations,
    createdDate: props.metadata.created,
    __typename: props.metadata.__typename,
    route: props.metadata.route,
  };

  const repostProps = {
    modalName: `repost_${metadata.__typename}_${metadata.id}`,
    repostPreviewProps: {
      feedSectionItem: { object: props.metadata },
      photos: props.photos,
      member: props.member,
      actor: props.actor,
      actorForUrl: props.actorForUrl,
      metadata: props.metadata,
    },
    actor: props.actor,
    socialStatistics: metadata.socialStatistics,
  };

  const socialActionBar = (
    <SocialActionBar>
      {/* TRVX-13661: Likes -> Helpful Tech Debt */}
      <LikeAction
        item={metadata}
        socialObject={{ objectType: 'MEDIA_BATCH', objectId: `${metadata.id}` }}
      />
      <NestedSocialAction>
        {/* Share: TRVX-9358 */}
        {featureIsEnabled('social_ugc_share') && props?.metadata?.route?.url ? (
          <ShareCta
            url={`${metadata.route.url}`}
            itemType={metadata.__typename}
            itemId={`${metadata.id}`}
            styleAsSocialAction
            alignEdge="right"
            repostProps={repostProps}
          />
        ) : (
          <DisabledSocialAction actionType="Share" />
        )}
      </NestedSocialAction>
    </SocialActionBar>
  );

  const socialStatisticsBar = (
    <SocialStatisticsBar
      stats={metadata.socialStatistics}
      socialRef={{
        type: metadata.__typename,
        id: `${metadata.id}`,
      }}
      socialProofParams={{ displayName: getDisplayName(props.actor) }}
      deduplicate
    />
  );

  return (
    <MediaBatchPhotoSection
      {...props}
      socialActionBar={socialActionBar}
      socialStatisticsBar={socialStatisticsBar}
    />
  );
};

MediaBatchPhotoSectionWrap.defaultProps = {
  isSingleObject: false,
  member: null,
  actor: null,
  actorForUrl: undefined,
  deleteObject: null,
  untagObject: null,
  layout: 'FULL',
};

export default MediaBatchPhotoSectionWrap;
